import { render, staticRenderFns } from "./TeacherIcon.vue?vue&type=template&id=7a1448a8&scoped=true"
import script from "./TeacherIcon.vue?vue&type=script&lang=ts"
export * from "./TeacherIcon.vue?vue&type=script&lang=ts"
import style0 from "./TeacherIcon.vue?vue&type=style&index=0&id=7a1448a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1448a8",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
